export var ReservedListTypeEnum;
(function (ReservedListTypeEnum) {
    ReservedListTypeEnum["AllContacts"] = "AllContacts";
    ReservedListTypeEnum["CommunicationPreference"] = "CommunicationPreference";
    ReservedListTypeEnum["ActiveMembers"] = "ActiveMembers";
    ReservedListTypeEnum["AutoRenewMembers"] = "AutoRenewMembers";
    ReservedListTypeEnum["ExpiringMembers"] = "ExpiringMembers";
    ReservedListTypeEnum["LapsedMembers"] = "LapsedMembers";
    ReservedListTypeEnum["RecurringDonors"] = "RecurringDonors";
    ReservedListTypeEnum["LapsedRecurringDonors"] = "LapsedRecurringDonors";
    ReservedListTypeEnum["TotalSupporters"] = "TotalSupporters";
    ReservedListTypeEnum["CampaignGuests"] = "CampaignGuests";
})(ReservedListTypeEnum || (ReservedListTypeEnum = {}));
export var ContactListCreatedStatus;
(function (ContactListCreatedStatus) {
    ContactListCreatedStatus["Automatic"] = "automatic";
    ContactListCreatedStatus["Imported"] = "imported";
    ContactListCreatedStatus["Manual"] = "manual";
})(ContactListCreatedStatus || (ContactListCreatedStatus = {}));
